import ClaimService from './services/ClaimService';
import ActivityService from 'customerEdge/gateway/claim/services/ActivityService_PSA';
import 'edge/claim/app';

export default angular.module('edge.gateway.claim.app', ['edge.claim.app'])

    .factory('claim.ClaimService', ClaimService)
    .factory('claim.ActivityService', ActivityService)

    .value('claimDetailsLinks', {
        previousPage: 'policies.detail.summary({policyNumber:details.claim.policy.policyNumber})',
        policyDetails: 'policies.detail.summary({policyNumber:details.claim.policy.policyNumber})',
        accountDetails: 'accounts.detail.summary({accountNumber:details.claim.policy.accountNumber})'
    })

    .value('claim.endpointConfig', {
        'uploadEndpoint': 'gatewayclaim/docupload',
        'documentsEndpoint': 'gatewayclaim/docs',
        'downloadEndpoint': 'document/gatewaydocument/claimDocument',
        'sessionServiceName': 'gatewayclaim/docs'
    });